<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : !disabled ? '修改' : '查看'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="dataRule"
      label-width="80px"
      @keyup.enter.native="dataFormSubmit()"
    >
      <el-form-item label="用户ID" prop="userId">
        <el-input
          v-model="dataForm.userId"
          :disabled="disabled"
          placeholder="用户ID"
        />
      </el-form-item>
      <el-form-item label="用户昵称" prop="nickname">
        <el-input
          v-model="dataForm.nickname"
          :disabled="disabled"
          placeholder="用户昵称"
        />
      </el-form-item>
      <el-form-item label="待取佣金" prop="amountAvailable">
        <el-input
          v-model="dataForm.amountAvailable"
          :disabled="true"
          placeholder="待取佣金"
        />
      </el-form-item>
      <el-form-item label="已取佣金" prop="amountWithdrawn">
        <el-input
          v-model="dataForm.amountWithdrawn"
          :disabled="true"
          placeholder="已取佣金"
        />
      </el-form-item>
      <el-form-item label="总手续费" prop="feeTotal">
        <el-input
          v-model="dataForm.feeTotal"
          :disabled="true"
          placeholder="总手续费"
        />
      </el-form-item>
      <el-form-item label="总佣金" prop="amountTotal">
        <el-input
          v-model="dataForm.amountTotal"
          :disabled="true"
          placeholder="总佣金"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!disabled" type="primary" @click="dataFormSubmit()"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      disabled: false,
      visible: false,
      dataForm: {
        userId: 0,
        nickname: '',
        amountAvailable: '',
        amountWithdrawn: '',
        feeTotal: '',
        amountTotal: '',
      },
      dataRule: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      },
    };
  },
  methods: {
    init(id, disabled) {
      this.disabled = disabled;
      this.dataForm.id = id || '';
      this.visible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields();
        if (this.dataForm.id) {
          this.$http({
            url: `/mall/distcommissionpool/info/${this.dataForm.id}`,
            method: 'get',
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.dataForm = data.distcommissionpool;
            }
          });
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: `/mall/distcommissionpool/${
              !this.dataForm.id ? 'save' : 'update'
            }`,
            method: 'post',
            data: this.dataForm,
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
              });
              this.visible = false;
              this.$emit('refreshDataList');
            }
          });
        }
      });
    },
  },
};
</script>
